import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useMakeRequest } from '../../hooks/useMakeRequest';
import { APPLICATION_API } from '../../resources/resource';

function InterviewTable({ data, refetch }) {
  // const updateApplication = `${process.env.REACT_APP_API_URL}application/updateApplication`;
  const currentUser = useSelector((state) => state.user.currentUser);
  const makeRequest = useMakeRequest()
  const navigate = useNavigate();

  const handleAccept = async (applicationId, applicant, index) => {
    navigate(`/makeOffer/${currentUser?._id}/${applicant[0]?._id}/${applicationId}/${index}`);
  };

  const handleReject = async (applicationId) => {
    makeRequest(
      APPLICATION_API + `/updateApplication/${applicationId}`,
      "PUT",
      {status: "Reject"},
      ()=>{refetch()},
      (error)=>{console.log(error)},
      ()=>{console.log()}
    )
  };

  return (
    <div className="mt-6 text-sm">
      <table className="w-full mx-auto border-collapse">
        <thead>
          <tr className="border-b-2 border-orange-300">
            <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wide">S/N</th>
            <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wide">Name</th>
            <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wide">Description</th>
            <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wide">Date of Interview</th>
            <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wide">Time of Interview</th>
            <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wide">Status</th>
            <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wide">Action</th>
            <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wide">Action</th>
          </tr>
        </thead>
        <tbody>
          {data.map((eachData, index) => {
            const lastInterview = eachData.interviews?.length
              ? eachData.interviews[eachData.interviews.length - 1]
              : {};
            const applicantName = `${eachData.applicant[0]?.firstName || ''} ${eachData.applicant[0]?.lastName || ''}`;

            return (
              <tr
                key={eachData._id || index} // Use unique ID if available
                className="border-b border-gray-200 hover:bg-orange-50 transition-colors duration-200"
              >
                <td className="px-6 py-3 text-gray-800 text-xs font-medium uppercase">{index + 1}</td>
                <td className="px-6 py-3 text-gray-800 text-xs font-medium uppercase">{applicantName}</td>
                <td className="px-6 py-3 text-gray-800 text-xs font-medium uppercase">{eachData.position || 'N/A'}</td>
                <td className="px-6 py-3 text-gray-800 text-xs font-medium uppercase">
                  {lastInterview.interviewDate || 'N/A'}
                </td>
                <td className="px-6 py-3 text-gray-800 text-xs font-medium uppercase">
                  {lastInterview.interviewTime || 'N/A'}
                </td>
                <td className="px-6 py-3 text-green-700 text-xs font-medium uppercase">{eachData.status || 'N/A'}</td>
                <td className="px-6 py-3">
                  <button
                    onClick={() => handleReject(eachData._id)}
                    className="bg-red-500 text-white px-4 py-2 rounded-md hover:bg-red-600 transition-colors duration-150 text-xs font-medium uppercase"
                  >
                    Reject
                  </button>
                </td>
                <td className="px-6 py-3">
                  <button
                    onClick={() => handleAccept(eachData._id, eachData.applicant, index)}
                    className="bg-green-500 text-white px-4 py-2 rounded-md hover:bg-green-600 transition-colors duration-150 text-xs font-medium uppercase"
                  >
                    Accept
                  </button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

export default InterviewTable;